import { useState } from 'react';
import { FormControl, Stack, FormLabel, Text, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../constants.js';
import { useCustomSIPHeaderForm } from '../hooks/useCustomSIPHeaderForm.js';

const CustomSIPHeaderName = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { updateFormData } = useCustomSIPHeaderForm();

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!errors[FORM_FIELD_PATHS.NAME] &&
                touched[FORM_FIELD_PATHS.NAME]
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Name <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter a name for your header. This is for reference
                        purposes only and will not form part of the header
                        itself.
                    </Text>
                </Box>
                <Field
                    component={NameField}
                    id={FORM_FIELD_PATHS.NAME}
                    name={FORM_FIELD_PATHS.NAME}
                    maxLength={10}
                    onChange={(e) => {
                        updateFormData(
                            FORM_FIELD_PATHS.NAME,
                            e.target.value.trim(),
                        );
                    }}
                    validate={(value) => {
                        if (!value || value === '') {
                            return 'Name is required';
                        }
                        if (value.length > 10) {
                            return 'Name must be less than 10 characters';
                        }
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter a name for your header"
                        ariaLabel="custom-sip-header-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default CustomSIPHeaderName;
